import {
  AHSeparator,
  AHText,
  AHWidgetTitleWrapper,
  Box,
  ColorType,
  TouchableBox,
  useScaleFactor,
} from "arkh";

import React from "react";

import { graphql, useFragment } from "react-relay";
import { useSetWidgetFocus } from "../useSetFocus";

import {
  WidgetIntegrationTurnpikeSize,
  WidgetIntegrationTurnpike_widgetIntegrationTurnpike$key,
} from "./__generated__/WidgetIntegrationTurnpike_widgetIntegrationTurnpike.graphql";
import { View } from "react-native";
import { WidgetIntegrationTurnpikeAcceptanceTimeBar_integrationTurnpikeSummary$key } from "./__generated__/WidgetIntegrationTurnpikeAcceptanceTimeBar_integrationTurnpikeSummary.graphql";
import { WidgetIntegrationTurnpikeSmall_integrationTurnpikeSummary$key } from "./__generated__/WidgetIntegrationTurnpikeSmall_integrationTurnpikeSummary.graphql";
import { WidgetIntegrationTurnpikeLarge_integrationTurnpikeSummary$key } from "./__generated__/WidgetIntegrationTurnpikeLarge_integrationTurnpikeSummary.graphql";
import { WidgetIntegrationTurnpikeLargeResponseRatioDetail_integrationTurnpikeSummary$key } from "./__generated__/WidgetIntegrationTurnpikeLargeResponseRatioDetail_integrationTurnpikeSummary.graphql";
import { WidgetIntegrationTurnpikeResponseRatioBar_integrationTurnpikeSummary$key } from "./__generated__/WidgetIntegrationTurnpikeResponseRatioBar_integrationTurnpikeSummary.graphql";
import { WidgetIntegrationTurnpikeResponseRatioAcceptedPercentageNumber_integrationTurnpikeSummary$key } from "./__generated__/WidgetIntegrationTurnpikeResponseRatioAcceptedPercentageNumber_integrationTurnpikeSummary.graphql";
import { WidgetIntegrationTurnpikeResponseTotalNumber_integrationTurnpikeSummary$key } from "./__generated__/WidgetIntegrationTurnpikeResponseTotalNumber_integrationTurnpikeSummary.graphql";
import { WidgetIntegrationTurnpikeResponseAcceptanceTimeNumber_integrationTurnpikeSummary$key } from "./__generated__/WidgetIntegrationTurnpikeResponseAcceptanceTimeNumber_integrationTurnpikeSummary.graphql";
import { Image } from "expo-image";
export const WidgetIntegrationTurnpike = (props: {
  widget: WidgetIntegrationTurnpike_widgetIntegrationTurnpike$key;
  storecastId?: string;
  mode?: "FOCUS" | "IDLE";
  forceClientSize?: WidgetIntegrationTurnpikeSize;

  interactive?: undefined | false;
}) => {
  const widget = useFragment(
    graphql`
      fragment WidgetIntegrationTurnpike_widgetIntegrationTurnpike on WidgetIntegrationTurnpike {
        id
        turnpikeSize
        integration {
          summary {
            ...WidgetIntegrationTurnpikeSmall_integrationTurnpikeSummary
            ...WidgetIntegrationTurnpikeLarge_integrationTurnpikeSummary
          }
        }
      }
    `,
    props.widget
  );
  const setFocus = useSetWidgetFocus(widget.id, props.storecastId);

  const size = props.forceClientSize ?? widget.turnpikeSize;
  return (
    <TouchableBox
      disabled={props.mode !== "FOCUS"}
      onPress={props.mode === "FOCUS" ? () => setFocus() : undefined}
      color="surface"
      style={{
        flex: 1,
      }}
    >
      <View
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
        }}
      >
        <AHWidgetTitleWrapper>
          <Image
            style={{ flex: 1 }}
            contentFit="scale-down"
            contentPosition="left center"
            source={require("./TurnpikeLogo.png")}
          />
          <AHText type="subtitle">
            Rullande 7 dagar
          </AHText>
        </AHWidgetTitleWrapper>
      </View>
      {widget.integration.summary ? (
        <>
          {size === "TWO_X_ONE" ? (
            <Small summary={widget.integration.summary} />
          ) : (
            <Large summary={widget.integration.summary} />
          )}
        </>
      ) : null}
    </TouchableBox>
  );
};

function Small(props: {
  summary: WidgetIntegrationTurnpikeSmall_integrationTurnpikeSummary$key;
}) {
  const summary = useFragment(
    graphql`
      fragment WidgetIntegrationTurnpikeSmall_integrationTurnpikeSummary on IntegrationTurnpikeSummary {
        ...WidgetIntegrationTurnpikeAcceptanceTimeBar_integrationTurnpikeSummary
        ...WidgetIntegrationTurnpikeResponseRatioBar_integrationTurnpikeSummary
        ...WidgetIntegrationTurnpikeResponseRatioAcceptedPercentageNumber_integrationTurnpikeSummary
        ...WidgetIntegrationTurnpikeResponseTotalNumber_integrationTurnpikeSummary
        ...WidgetIntegrationTurnpikeResponseAcceptanceTimeNumber_integrationTurnpikeSummary
      }
    `,
    props.summary
  );

  return (
    <View
      style={{
        flexDirection: "row",
        flex: 1,
        alignItems: "center",
      }}
    >
      <CenterAlignedBlock>
        <Header>
          <Label text="Acceptance Time" />
        </Header>
        <ResponseAcceptanceTimeNumber summary={summary} />
        <Footer>
          <AcceptenceTimeBar summary={summary} />
        </Footer>
      </CenterAlignedBlock>
      <CenterAlignedBlock>
        <Header>
          <Label text="Total Actions" />
        </Header>
        <ResponseTotalNumber summary={summary} />
        <Footer />
      </CenterAlignedBlock>
      <CenterAlignedBlock>
        <Header>
          <Label text="Response Ratio" />
        </Header>
        <ResponseRatioAcceptedPercentageNumber summary={summary} />
        <Footer>
          <ResponseRationBar summary={summary} />
        </Footer>
      </CenterAlignedBlock>
    </View>
  );
}

function Large(props: {
  summary: WidgetIntegrationTurnpikeLarge_integrationTurnpikeSummary$key;
}) {
  const summary = useFragment(
    graphql`
      fragment WidgetIntegrationTurnpikeLarge_integrationTurnpikeSummary on IntegrationTurnpikeSummary {
        ...WidgetIntegrationTurnpikeAcceptanceTimeBar_integrationTurnpikeSummary
        ...WidgetIntegrationTurnpikeLargeResponseRatioDetail_integrationTurnpikeSummary
        ...WidgetIntegrationTurnpikeResponseRatioBar_integrationTurnpikeSummary
        ...WidgetIntegrationTurnpikeResponseRatioAcceptedPercentageNumber_integrationTurnpikeSummary
        ...WidgetIntegrationTurnpikeResponseTotalNumber_integrationTurnpikeSummary
        ...WidgetIntegrationTurnpikeResponseAcceptanceTimeNumber_integrationTurnpikeSummary
      }
    `,
    props.summary
  );

  return (
    <Box
      style={{
        flexDirection: "column",
        flex: 1,
      }}
      spaceHorizontal="large"
    >
      <Box
        style={{
          flex: 1,
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <LeftAlignedBlock>
          <Header>
            <Label text="Total Actions" />
          </Header>
          <ResponseTotalNumber summary={summary} />
          <Footer />
        </LeftAlignedBlock>
        <LeftAlignedBlock>
          <Header>
            <Label text="Acceptance Time" />
          </Header>
          <ResponseAcceptanceTimeNumber summary={summary} />
          <Footer>
            <AcceptenceTimeBar summary={summary} />
          </Footer>
        </LeftAlignedBlock>
      </Box>
      <AHSeparator />
      <Box style={{ flex: 1, flexDirection: "row", alignItems: "center" }}>
        <LeftAlignedBlock>
          <Header>
            <Label text="Response Ratio" />
          </Header>
          <ResponseRatioDetail summary={summary} />
        </LeftAlignedBlock>
        <LeftAlignedBlock>
          <Header />

          <ResponseRatioAcceptedPercentageNumber summary={summary} />
          <Footer>
            <ResponseRationBar summary={summary} />
          </Footer>
        </LeftAlignedBlock>
      </Box>
    </Box>
  );
}

function ResponseRatioAcceptedPercentageNumber(props: {
  summary: WidgetIntegrationTurnpikeResponseRatioAcceptedPercentageNumber_integrationTurnpikeSummary$key;
}) {
  const summary = useFragment(
    graphql`
      fragment WidgetIntegrationTurnpikeResponseRatioAcceptedPercentageNumber_integrationTurnpikeSummary on IntegrationTurnpikeSummary {
        accepted
        total
      }
    `,
    props.summary
  );

  if (summary.total === 0) {
    return <AHText style={{ textAlign: "center" }}>No Data</AHText>;
  }
  return (
    <NumberLabel
      value={Math.round((summary.accepted / summary.total) * 100)}
      suffix="%"
    />
  );
}

function ResponseTotalNumber(props: {
  summary: WidgetIntegrationTurnpikeResponseTotalNumber_integrationTurnpikeSummary$key;
}) {
  const summary = useFragment(
    graphql`
      fragment WidgetIntegrationTurnpikeResponseTotalNumber_integrationTurnpikeSummary on IntegrationTurnpikeSummary {
        total
      }
    `,
    props.summary
  );

  return <NumberLabel value={summary.total} />;
}

function ResponseAcceptanceTimeNumber(props: {
  summary: WidgetIntegrationTurnpikeResponseAcceptanceTimeNumber_integrationTurnpikeSummary$key;
}) {
  const summary = useFragment(
    graphql`
      fragment WidgetIntegrationTurnpikeResponseAcceptanceTimeNumber_integrationTurnpikeSummary on IntegrationTurnpikeSummary {
        acceptedTimeAverageInMs
      }
    `,
    props.summary
  );

  if (summary.acceptedTimeAverageInMs === null) {
    return <NumberLabel value="-" suffix="" />;
  }

  return (
    <NumberLabel
      value={Math.round(summary.acceptedTimeAverageInMs / 1000)}
      suffix="sec"
    />
  );
}

function ResponseRatioDetail(props: {
  summary: WidgetIntegrationTurnpikeLargeResponseRatioDetail_integrationTurnpikeSummary$key;
}) {
  const summary = useFragment(
    graphql`
      fragment WidgetIntegrationTurnpikeLargeResponseRatioDetail_integrationTurnpikeSummary on IntegrationTurnpikeSummary {
        accepted
        unanswered
        rejected
        total
      }
    `,
    props.summary
  );

  return (
    <Box spaceRight="xlarge">
      <ResponseRatioRow
        label="Accepted"
        color="positive"
        value={summary.accepted / summary.total}
      />
      <ResponseRatioRow
        label="Declined"
        color="negative"
        value={summary.rejected / summary.total}
      />
      <ResponseRatioRow
        label="No response"
        color="semiNegative"
        value={summary.unanswered / summary.total}
      />
    </Box>
  );
}

const SPREAD = 15;

function ResponseRatioRow(props: {
  label: string;
  value: number;
  color: ColorType;
}) {
  return (
    <Box
      spaceTop="small"
      style={{
        flexDirection: "row",

        alignItems: "center",
      }}
    >
      <AHText color="darkText" style={{ flex: 1 }} type="subtitle">
        {props.label}
      </AHText>
      <Box
        spaceHorizontal="small"
        spaceVertical="xxsmall"
        cornerRadius="medium"
        color={props.color}
      >
        <AHText type="subtitle" color="lightText">
          {Number.isNaN(props.value)
            ? "-"
            : Math.round(props.value * 100) + "%"}
        </AHText>
      </Box>
    </Box>
  );
}

function Header(props: { children?: React.ReactNode }) {
  const sf = useScaleFactor();
  return (
    <Box
      style={{
        height: SPREAD * sf,
        justifyContent: "center",
      }}
    >
      {props.children}
    </Box>
  );
}
function Footer(props: { children?: React.ReactNode }) {
  const sf = useScaleFactor();
  return (
    <Box
      style={{
        height: SPREAD * sf,
        justifyContent: "center",
        width: "100%",
      }}
    >
      {props.children}
    </Box>
  );
}

function useBarHeight() {
  const sf = useScaleFactor();
  return SPREAD * sf;
}

function AcceptenceTimeBar(props: {
  summary: WidgetIntegrationTurnpikeAcceptanceTimeBar_integrationTurnpikeSummary$key;
}) {
  const { acceptedTimeAverageInMs } = useFragment(
    graphql`
      fragment WidgetIntegrationTurnpikeAcceptanceTimeBar_integrationTurnpikeSummary on IntegrationTurnpikeSummary {
        acceptedTimeAverageInMs
      }
    `,
    props.summary
  );

  const height = useBarHeight();

  if (acceptedTimeAverageInMs === null) {
    return null;
  }

  const fraction = Math.max(
    0,
    Math.min(1, acceptedTimeAverageInMs / 1000 / 60)
  );
  return (
    <Box
      cornerRadius="xsmall"
      style={{ width: "100%", overflow: "hidden", flexDirection: "row" }}
      color="surfaceBorder"
    >
      <Box
        color="primary"
        style={{
          width: `${fraction * 100}%`,
          height,
        }}
      />
      <Box
        color="surfaceBorder"
        style={{
          width: `${(1 - fraction) * 100}%`,
          height,
        }}
      />
      {[10, 20, 30, 40, 50].map((v) => (
        <Box
          key={v}
          color="primary"
          style={{
            left: `${(v / 60) * 100}%`,
            position: "absolute",
            height,
            marginLeft: -1,
            width: 2,
            backgroundColor: "#FFF",
          }}
        />
      ))}
    </Box>
  );
}

function ResponseRationBar(props: {
  summary: WidgetIntegrationTurnpikeResponseRatioBar_integrationTurnpikeSummary$key;
}) {
  const height = useBarHeight();

  const summary = useFragment(
    graphql`
      fragment WidgetIntegrationTurnpikeResponseRatioBar_integrationTurnpikeSummary on IntegrationTurnpikeSummary {
        accepted
        unanswered
        rejected
      }
    `,
    props.summary
  );

  return (
    <Box
      cornerRadius="xsmall"
      style={{
        width: "100%",
        overflow: "hidden",
        flexDirection: "row",
      }}
      color="surfaceBorder"
    >
      <Box
        color="positive"
        style={{
          flex: summary.accepted,
          height,
        }}
      />
      <Box
        color="negative"
        style={{
          flex: summary.rejected,
          height,
        }}
      />
      <Box
        color="semiNegative"
        style={{
          flex: summary.unanswered,
          height,
        }}
      />
    </Box>
  );
}

function LeftAlignedBlock(props: { children: React.ReactNode }) {
  const sf = useScaleFactor();
  return (
    <Box style={{ flex: 1, height: 115 * sf, justifyContent: "space-between" }}>
      {props.children}
    </Box>
  );
}

function CenterAlignedBlock(props: { children: React.ReactNode }) {
  const sf = useScaleFactor();
  return (
    <Box
      spaceHorizontal="medium"
      style={{
        flex: 1,
        alignItems: "center",
        height: 115 * sf,
        justifyContent: "space-between",
      }}
    >
      {props.children}
    </Box>
  );
}

function Label(props: { text: React.ReactNode }) {
  return <AHText type="subtitle">{props.text}</AHText>;
}
function NumberLabel(props: {
  value: React.ReactNode;
  suffix?: React.ReactNode;
}) {
  return (
    <AHText>
      <AHText type="stat-number-large">{props.value}</AHText>
      {props.suffix ? <AHText type="body"> {props.suffix}</AHText> : null}
    </AHText>
  );
}
